export enum UserField {
  UUID = 'UUID',
  USER_TYPE = 'userType'
}

export const userManagementEndpoint = 'lifesize.user';
export const userCountUri = 'user/count';
